import React from "react";

import api from "../../services/api";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import estados from "../../services/estados";

import HeaderV2 from "../../components/headerV2";

import { store } from "react-notifications-component";
import downloadFile from "../../utils/downloadFile";

import Search from "../../components/search";
import ButtonList from '../../components/button-list';
import ButtonV2 from '../../components/button/button_v2';
import CircleData from '../../components/nova-home/circle-data';
import CardRTwithGraphic from "../../components/cardRTwithGraphic";
import CalendaryEvent from "../../components/nova-home/calendary-event";
import PaginatorV2 from "../../components/paginator/indexV2";
import ButtonFilter from "../../components/button-filter/indexV2";
import FilterCell from "../../components/FilterCell";
import SwitchLayout from "../../components/SwitchLayout";

import IconPlusWhite from '../../assets/icons/iconAddHeader.svg';
import ArrowDown from '../../assets/icons/icon-arrow-down-circle-gray.png';

import * as S from './styles'
import { theme } from "../../styles/theme";
import { TaglineM, TaglineP, H6, BodyPSpan } from "../../styles/stylesTypography";
import ItemNotFound from "../../assets/img-undraw-search.svg";

import IconPenEdit from '../../assets/icons/icon-pen-edit.png';
import IconBarChartGray from '../../assets/icons/icon-bar-chart-gray.png';


import ModalTesteGratisAcabou from '../../components/modal/modalFuncaoBloqueada';
import ImportarAgronomosModal from '../../components/modal/modalImportarAgronomos';
import ModalGeneric from '../../components/modal/modalGeneric';
import Paginator from "../../components/paginator";
// import TableWithLabelBlack from "../../components/TableWithLabelBlackV2/index.js";
import TableWithLabelBlackV2 from "../../components/TableWithLabelBlack/indexV2";
import { Loading } from "../../components/loading";
import { isTotvs, isTotvsProtheus } from "../../services/globalFunctions";

// Nome do estado por extenso como label (o value continua a sigla) - o
// ButtonFilterV2 já busca tanto pelo label quanto pelo value, então dá pra
// digitar "SP" ou "São Paulo" e encontrar a mesma opção.
const estadosAbreviados = estados.map(estado => ({
    value: estado.value,
    label: estado.label
}));

export const USER = "@userinfo";
export const VAL = "@validade";

class Agronomos extends React.Component {
    state = {
        agronomos: [],
        creas: [],
        creaArts: [],
        offset: 0,
        limit: 12,
        totalAgronomos: 0,
        hideButton: false,
        loading: false,
        result: "",
        result2: [],
        size_screen: window.screen.width,
        importar: false,
        modalTesteGratisAcabou: false,
        user: JSON.parse(localStorage.getItem(USER)),
        val: JSON.parse(localStorage.getItem(VAL)),
        loading: false,
        loadingMore: false,
        loadingSearch: false,
        searchValue: "",
        order: { value: "modified", label: "Últimas atualizações", order: "DESC" },
        // Filtro com checkbox
        selectedOptions: { uf: [] },
        openSelect: "",
        showAll: false,
        pageCards: 1,
        itemsPerPageCards: 4,
        totalCards: 0,
        currentCardsCount: 0,
        loadingReport: false,
        width: window.innerWidth,
        layoutView: window.innerWidth < 760 ? "cards" : "table",
        layoutLoading: false,
        userLicencasData: {},
        showTooltipAdicionar: false,
        showModalImportAgronomos: false,
        showModalPlanoSemRT: false,
        verificandoLimiteRT: false,
    };

    searchDebounce = null;
    tooltipAdicionarRef = React.createRef();
    buttonAdicionarRef = React.createRef();

    toggleSelect = (key) => {
        this.setState(({ openSelect }) => ({ openSelect: openSelect === key ? "" : key }));
    }

    setLayoutView = (layoutView) => {
        if (layoutView === this.state.layoutView) return;
        if (this.state.layoutLoading) return;
        this.setState({ layoutLoading: true });
        setTimeout(() => {
            this.setState({ layoutView, layoutLoading: false });
        }, 350);
    }

    toggleShowAll = () => {
        this.setState(prev => {
            const nextShowAll = !prev.showAll;
            const newLimit = nextShowAll ? 12 : 4;
            const newPageCards = Math.floor(prev.offset / newLimit) + 1;
            return {
                showAll: nextShowAll,
                pageCards: newPageCards > 0 ? newPageCards : 1,
                itemsPerPageCards: newLimit,
                limit: newLimit,
                offset: prev.offset,
            };
        });
    }

    handleCardPageChange = (limit, offset) => {
        const page = Math.floor(offset / limit) + 1;
        this.setState({ itemsPerPageCards: limit, pageCards: page });
        this.updateLimitOffset(limit, offset);
    }

    // Chamado quando o usuário confirma a seleção pendente no ButtonFilterV2
    // (botão APLICAR) - substitui o antigo addSelectOption (que aplicava a
    // cada clique numa opção); agora a busca só é refeita ao confirmar.
    handleApplyFilter = (key, values) => {
        this.setState({ selectedOptions: { ...this.state.selectedOptions, [key]: values } }, () => {
            this.updateValues(this.state.searchValue, values, 1);
        });
    }

    // Remove só um valor do resumo de filtros (o "x" de cada pilula no
    // FilterCell), reaplicando o filtro com o restante da seleção.
    handleRemoveFilterValue = (key, value) => {
        const current = this.state.selectedOptions[key] || [];
        this.handleApplyFilter(key, current.filter(v => v !== value));
    }

    // "LIMPAR FILTROS" do FilterCell - zera ESTADO e refaz a busca.
    handleClearAllFilters = () => {
        this.setState(
            { selectedOptions: { uf: [] } },
            () => this.updateValues(this.state.searchValue, [], 1)
        );
    }

    handleResize = () => {
        // Troca automaticamente pra cards ao entrar em largura mobile (e de
        // volta pra tabela ao sair) - só dispara quando o breakpoint muda de
        // verdade, sem brigar com uma escolha manual dentro do mesmo tamanho.
        const nextWidth = window.innerWidth;
        this.setState((prevState) => {
            const wasMobile = prevState.width < 760;
            const isMobile = nextWidth < 760;
            if (wasMobile === isMobile) {
                return { size_screen: nextWidth, width: nextWidth };
            }
            return {
                size_screen: nextWidth,
                width: nextWidth,
                layoutView: isMobile ? "cards" : "table"
            };
        });
    }

    updateResposta = async (resposta) => {
        if (resposta == 0) {
            this.setState({importar: false})
        }
    }
    
    updateValues = async (text, estado, search) => {
        const isEstadoEmpty = Array.isArray(estado) ? estado.length === 0 : !estado;
        if (search == 1) {
            this.setState({ result2: estado, result: text });
            if (!text && isEstadoEmpty) {
                this.getAgronomists();
            } else {
                this.search(text, estado, this.state.limit, 0);
            }
        } else {
            this.setState({ result: text, result2: Array.isArray(estado) ? estado : estado ? [estado] : [] });
        }
    }

    sortAgronomos = (list) => {
        const order = this.state.order || {};
        const field = order.value;
        const direction = (order.order || 'ASC').toUpperCase();

        const getPrimaryCrea = (a) => {
            const creas = Array.isArray(a?.agro_creas) ? a.agro_creas : [];
            return creas.find(c => c?.status === 1) || creas[0] || null;
        };

        const getFieldValue = (a) => {
            if (field === 'nome') return (a?.nome || '').toString().toLowerCase();
            if (field === 'modified') return new Date(a?.modified || 0).getTime();
            if (field === 'crea') return (getPrimaryCrea(a)?.crea || '').toString().toLowerCase();
            return '';
        };

        const sorted = [...(Array.isArray(list) ? list : [])].sort((a, b) => {
            const av = getFieldValue(a);
            const bv = getFieldValue(b);
            if (typeof av === 'number' && typeof bv === 'number') return av - bv;
            return String(av).localeCompare(String(bv), 'pt-BR');
        });

        return direction === 'DESC' ? sorted.reverse() : sorted;
    }

    filterByEstados = (list, estados) => {
        const selected = Array.isArray(estados) ? estados.filter(Boolean) : [];
        if (selected.length <= 1) return Array.isArray(list) ? list : [];

        const hasSelectedEstado = (a) => {
            const creas = Array.isArray(a?.agro_creas) ? a.agro_creas : [];
            if (creas.some(c => c?.estado && selected.includes(c.estado))) return true;
            if (a?.estado && selected.includes(a.estado)) return true;
            return false;
        };

        return (Array.isArray(list) ? list : []).filter(hasSelectedEstado);
    }

    // função para pegar os agronomos na API
    getAgronomists = async () => {
        this.setState({ loadingSearch: true });

        try {
            const { limit, offset } = this.state;

            const payload = { search: "", estado: "" };

            const response = await api.post(`/agronomos/pesquisa?limit=${limit}&offset=${offset}`, payload);
            const raiz = response?.data ?? {};
            const data = raiz?.data ?? {};
            const lista = Array.isArray(data?.agronomists) ? data.agronomists : [];
            const total = typeof data?.total === 'number' ? data.total : lista.length;
            const sorted = this.sortAgronomos(lista);

            this.setState({ 
                agronomos: sorted || [], 
                totalAgronomos: total || 0,
                loadingSearch: false, 
                hideButton: false 
            });

        } catch (error) {
            console.error('Erro ao carregar agrônomos:', error);
            this.setState({ 
                agronomos: [],
                loadingSearch: false, 
                hideButton: true 
            });
        }
    }

    //função para realizar buscas dos campos
    search = async (result, result2, limit, offset) => {
        this.setState({loadingSearch: true, agronomos: []});
        
        try {
            const search = result;
            const estados = Array.isArray(result2) ? result2 : result2 ? [result2] : [];
            const estado = estados.length === 1 ? estados[0] : "";
            const payload = { search, estado };

            const response = await api.post(`/agronomos/pesquisa?limit=${limit}&offset=${offset}`, payload);
            const raiz = response?.data ?? {};
            const data = raiz?.data ?? {};
            const listaRaw = Array.isArray(data?.agronomists) ? data.agronomists : [];
            const lista = this.filterByEstados(listaRaw, estados);
            const total = typeof data?.total === 'number' ? data.total : lista.length;
            const sorted = this.sortAgronomos(lista);

            this.setState({ 
                agronomos: sorted, 
                totalAgronomos: total || 0,
                loadingSearch: false
            });
        } catch (error) {
            this.setState({loadingSearch: false});
        }
    };

    //funcao para realizar a limpeza do filtro de buscas
    cleanFilter = () => {
        this.setState({
            result: "",
            result2: [],
            offset: 0
        }, () => {
            // Chama getAgronomists após limpar os filtros
            this.getAgronomists();
        });
    };

    //função para realizar o download do Xlsx
    getXlms = async () => {
        this.setState({ loading: true, loadingReport: true });
        window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';
        try {
            const response = await api.get("/agronomos/relatorio");

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-agronomos.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 6000, onScreen: true }
            });
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-620 Nao foi possivel gerar o relatorio - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 5000, onScreen: true }
            });
        } finally {
            this.setState({ loading: false, loadingReport: false });
            window.onbeforeunload = null;
        }
    };

    //função para o botão  VER MAIS exibir mais agronomos na tela
    loadMore = async () => {
        this.setState({ loadingMore: true, hideButton: true });
        const { limit, offset, agronomos, result, result2 } = this.state;
        const newOffset = limit + offset;

        try {
            const estados = Array.isArray(result2) ? result2 : result2 ? [result2] : [];
            const estado = estados.length === 1 ? estados[0] : "";
            const payload = { search: result || "", estado };

            const response = await api.post(`/agronomos/pesquisa?limit=${limit}&offset=${newOffset}`, payload);
            const data = response?.data?.data ?? {};
            const newAgronomosRaw = Array.isArray(data?.agronomists) ? data.agronomists : [];
            const newAgronomos = this.filterByEstados(newAgronomosRaw, estados);

            const agronomosConcat = agronomos.concat(newAgronomos);
            const sorted = this.sortAgronomos(agronomosConcat);

            this.setState({
                agronomos: sorted,
                offset: newOffset,
                hideButton: false
            });
        } catch (err) {
            console.error('Erro ao carregar mais agrônomos:', err);
            this.setState({ hideButton: true });
        }

        this.setState({ loadingMore: false });
    };

    onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.search(this.state.result, this.state.result2, this.state.limit, 0);
        }
    }

    validateResult = (e) => {
    }

    openAdd = () => {
        this.props.history.push('/agronomos/add');
    }

    updateLimitOffset = (l,o) => {
        if (l !== this.state.limit || o !== this.state.offset) {
            this.setState({
                limit: l,
                offset: o
            })

            this.search(this.state.result, this.state.result2, l, o);
        }
    }

    updateOrder = (e) => {
        this.setState({ order: e, offset: 0 }, () => {
            this.search(this.state.result, this.state.result2, this.state.limit, 0);
        });
    }

    componentDidMount() {
        this.getAgronomists();
        this.getAgronomistsCreaArts();
        window.addEventListener("resize", this.handleResize);
        document.addEventListener("mousedown", this.handleClickOutsideTooltip);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        document.removeEventListener("mousedown", this.handleClickOutsideTooltip);
    }

    handleClickOutsideTooltip = (event) => {
        if (
            this.tooltipAdicionarRef.current &&
            !this.tooltipAdicionarRef.current.contains(event.target) &&
            this.buttonAdicionarRef.current &&
            !this.buttonAdicionarRef.current.contains(event.target)
        ) {
            this.setState({ showTooltipAdicionar: false });
        }
    }

    toggleTooltipAdicionar = async () => {
        if (this.state.showTooltipAdicionar) {
            this.setState({ showTooltipAdicionar: false });
            return;
        }

        // Plano Basic/Pré-pago com o limite atingido não pode adquirir mais licenças (ERRO-708)
        this.setState({ verificandoLimiteRT: true });
        try {
            await api.get('/agronomos/limite');
        } catch (error) {
            if (JSON.stringify(error?.response?.data || '').includes('ERRO-708')) {
                this.setState({ verificandoLimiteRT: false, showModalPlanoSemRT: true });
                return;
            }
        }
        this.setState({ verificandoLimiteRT: false, showTooltipAdicionar: true });
    }

    handleCadastrarRT = () => {
        this.setState({ showTooltipAdicionar: false });
        window.location.href = '/agronomos/add';
    }

    handleImportarRT = () => {
        this.setState({ showTooltipAdicionar: false, showModalImportAgronomos: true });
    }

     getNumberAgronomos = async () => {
        try {
            const response = await api.get(`/users/qtd-licencas-agronomos`);
            this.setState({ userLicencasData: response.data });
        } catch (error) {}
    }

    getAgronomistsCreaArts = async () => {
        try {
            const response = await api.get(`/agronomos/crea/arts`);
            const raiz = response?.data ?? {};
            const dados = Array.isArray(raiz?.data) ? raiz.data : (Array.isArray(raiz) ? raiz : []);
            this.setState({ creaArts: dados });

        } catch (error) {
        }
    }

    //renderização
    render() {
        const { agronomos, loadingSearch, size_screen, importar, user, modalTesteGratisAcabou, val, totalAgronomos, layoutView, layoutLoading, creaArts, userLicencasData } = this.state;
        const isTableView = layoutView === "table";
        const hasAgronomos = Array.isArray(agronomos) && agronomos.length > 0;
        const isBusy = layoutLoading || loadingSearch;
        const filterChipItems = (this.state.selectedOptions.uf || []).map(value => ({
            id: `uf_${value}`,
            label: estados.find(estado => estado.value === value)?.label || value,
            onRemove: () => this.handleRemoveFilterValue('uf', value)
        }));

        const firstCreaArt = Array.isArray(creaArts) ? creaArts[0] : undefined;
        const secondCreaArt = Array.isArray(creaArts) ? creaArts[1] : undefined;
        const thirdCreaArt =
            Array.isArray(creaArts) && creaArts.length >= 3
                ? creaArts[creaArts.length - 1]
                : undefined;

        // console.log("agronomos => ",agronomos, "loadingSearch =>", loadingSearch, "size_screen =>", size_screen, "importar =>", importar, "user =>", user, "modalTesteGratisAcabou =>", modalTesteGratisAcabou, "val =>", val, "totalAgronomos =>", totalAgronomos);
        return (
            <S.ContainerPage>
                <HeaderV2 title="Responsáveis técnicos" />

                <S.ContainerBody>
                    {(userLicencasData?.qtd_licencas != null || userLicencasData?.qtd_adquirida != null) && (
                        <div style={{width: '100%', height: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <BodyPSpan color={theme.colors.gray.Cinza_2} style={{width: 'auto'}}>
                                Quantidade de agrônomos do seu plano: {userLicencasData?.qtd_licencas?.toString()}/{userLicencasData?.qtd_adquirida?.toString()}
                            </BodyPSpan>
                        </div>
                    )}

                    <S.ContainerFiltersAndButtons>
                        <S.ConatinerInputAndFilter>
                            <SwitchLayout
                                isTableView={isTableView}
                                onClick={() => this.setLayoutView(isTableView ? "cards" : "table")}
                            />

                        <S.ContainerInput>
                            <Search 
                                placeholder="Nome do RT, CREA, ART/TRT, etc."
                                value={this.state.searchValue}
                                onChange={(e) => { 
                                    const val = e.target.value;
                                    this.setState({ searchValue: val });
                                    if (this.searchDebounce) clearTimeout(this.searchDebounce);
                                    this.searchDebounce = setTimeout(() => {
                                        this.updateValues(val, this.state.result2, 1);
                                    }, 300);
                                }}
                                onClear={() => { 
                                    this.setState({ searchValue: "" });
                                    this.updateValues("", this.state.result2, 1);
                                }}
                                />
                        </S.ContainerInput>

                        <ButtonFilter
                            key_value="uf"
                            selectedOptions={this.state.selectedOptions}
                            label={this.state.width && this.state.width > 760 ? "Estado" : "UF"}
                            options={{ uf: estadosAbreviados }}
                            toggleSelect={this.toggleSelect}
                            onApply={this.handleApplyFilter}
                            openSelect={this.state.openSelect}
                            justIconFilter={true}
                            borderColor={theme.colors.gray.Cinza_7}
                            showClearFilter={false}
                        />

                        <ButtonList
                            id="order"
                            width="200px"
                            border="none"
                            options={[
                                { value: "modified", label: "Últimas atualizações", order: "DESC" },
                                { value: "nome", label: "Responsavel Técnico", order: "ASC" },
                                { value: "crea", label: "CREA", order: "ASC" }
                            ]}
                            onSelected={(e) => this.updateOrder(e)}
                            value={this.state.order}
                        />

                        {this.state.width && this.state.width > 760 && (
                            <ButtonV2 
                                width='112px'
                                height='42px'
                                value='RELATÓRIO'
                                outline={!this.state.loading}
                                disabled={false}
                                onClick={() => this.getXlms()}
                                loading={this.state.loading}
                                color="#21262f"
                            />
                        )}

                        <S.ButtonAndTooltipWrapper ref={this.buttonAdicionarRef}>
                            <ButtonV2
                                width='179px'
                                height='42px'
                                value={this.state.width && this.state.width > 760 ? 'ADICIONAR RT' : 'ADICIONAR'}
                                outline={false}
                                disabled={isTotvsProtheus() && this.state.user?.agro_permission_id !== 4}
                                onClick={!(isTotvsProtheus() && this.state.user?.agro_permission_id !== 4) ? this.toggleTooltipAdicionar : undefined}
                                loading={this.state.verificandoLimiteRT}
                                imagePlus={true}
                            />

                            {this.state.showTooltipAdicionar && (
                                <S.Tooltip ref={this.tooltipAdicionarRef}>
                                    <S.TooltipOption type="button" onClick={this.handleCadastrarRT}>
                                        <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                                            <circle cx="8" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5" />
                                            <path d="M3 13.5c.7-2.3 2.7-3.5 5-3.5s4.3 1.2 5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                        </svg>
                                        <S.TooltipOptionText>
                                            <b>Cadastrar manualmente</b>
                                            <span>Preencha o formulário completo</span>
                                        </S.TooltipOptionText>
                                    </S.TooltipOption>

                                    <S.TooltipOption type="button" onClick={this.handleImportarRT}>
                                        <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                                            <rect x="2" y="2.5" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
                                            <path d="M2 6h12M6 2.5v11" stroke="currentColor" strokeWidth="1.4" />
                                        </svg>
                                        <S.TooltipOptionText>
                                            <b>Importar com planilha</b>
                                            <span>Envie a planilha seguindo nosso modelo</span>
                                        </S.TooltipOptionText>
                                    </S.TooltipOption>
                                </S.Tooltip>
                            )}
                        </S.ButtonAndTooltipWrapper>
                        </S.ConatinerInputAndFilter>
                    </S.ContainerFiltersAndButtons>

                    <FilterCell
                        items={filterChipItems}
                        onClearAll={filterChipItems.length > 0 ? this.handleClearAllFilters : undefined}
                    />

                    {isBusy ? (
                        <S.ContainerLoading>
                            <Loading size="80px" color={theme.colors.green.Verde_AgroReceita} />
                        </S.ContainerLoading>
                    ) : isTableView ? (
                        hasAgronomos ? (
                            <>
                                {/* <TableWithLabelBlack
                                    agronomos={agronomos}
                                    showAll={this.state.showAll}
                                    page={this.state.pageCards}
                                    itemsPerPage={this.state.itemsPerPageCards}
                                    serverSide={true}
                                    onCountChange={(total, count) => this.setState({ totalCards: total, currentCardsCount: count })}
                                /> */}

                                <TableWithLabelBlackV2
                                    agronomos={agronomos}
                                    showAll={this.state.showAll}
                                    page={this.state.pageCards}
                                    itemsPerPage={this.state.itemsPerPageCards}
                                    serverSide={true}
                                    enableDefaultRowNavigation={false}
                                    // getRowClickHref={(agronomo) => {
                                    //     const id = agronomo?.agronomist_id ?? agronomo?.id;
                                    //     return id ? `/agronomos/${id}` : null;
                                    // }}
                                    onCountChange={(total, count) => this.setState({ totalCards: total, currentCardsCount: count })}
                                    actionsColumn={{
                                        enabled: true,
                                        position: "first",
                                        label: "AÇÕES",
                                        width: "100%",
                                        minWidth: "80px",
                                        maxWidth: "112px",
                                        justifyContent: "flex-start",
                                        buttons: [
                                            {
                                                key: "edit",
                                                icon: IconPenEdit,
                                                iconAlt: "Ícone de edição",
                                                tooltip: "Editar responsável técnico",
                                                ariaLabel: "Editar responsável técnico",
                                                href: (agronomo) => {
                                                    const id = agronomo?.agronomist_id ?? agronomo?.id;
                                                    return id ? `/agronomos/edit/${id}` : null;
                                                }
                                            },
                                            {
                                                key: "view",
                                                icon: IconBarChartGray,
                                                iconAlt: "Ícone de gráfico",
                                                tooltip: "Ver dados",
                                                ariaLabel: "Ver dados",
                                                href: (agronomo) => {
                                                    const id = agronomo?.agronomist_id ?? agronomo?.id;
                                                    return id ? `/agronomos/${id}` : null;
                                                }
                                            }
                                        ]
                                    }}
                                />
                            </>
                        ) : null
                    ) : (
                        hasAgronomos ? (
                            <CardRTwithGraphic
                                agronomos={agronomos}
                                showAll={this.state.showAll}
                                page={this.state.pageCards}
                                itemsPerPage={this.state.itemsPerPageCards}
                                serverSide={true}
                                onCountChange={(total, count) => this.setState({ totalCards: total, currentCardsCount: count })}
                            />
                        ) : null
                    )}

                    {!isBusy && this.state.showAll && this.state.totalAgronomos > this.state.itemsPerPageCards && (
                        <PaginatorV2
                            perPage={this.state.itemsPerPageCards}
                            total={this.state.totalAgronomos}
                            onChange={(limit, offset) => this.handleCardPageChange(limit, offset)}
                            currentPage={this.state.pageCards}
                            totalItens={this.state.currentCardsCount}
                        />
                    )}

                    {!isBusy && !hasAgronomos && (
                        <S.ContainerItemNotFound>
                            <img src={ItemNotFound} alt="Ícone de pesquisa" />

                            <H6 color={theme.colors.gray.Cinza_2}>
                                Nenhum agronomo encontrado!
                            </H6>
                        </S.ContainerItemNotFound>
                    )}

                    {((this.state.totalAgronomos > 4 || this.state.agronomos.length > 4) && !isBusy) && (
                        <S.ButtonShowAll onClick={this.toggleShowAll}>
                            <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
                                {this.state.showAll ? 'Ver menos' : 'Ver todos'}
                            </TaglineP>

                            <img
                                src={ArrowDown}
                                alt="Ícone de flecha direcionada para baixo"
                                style={{
                                    transform: this.state.showAll ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease',
                                }}
                            />
                        </S.ButtonShowAll>
                    )}

                    <S.ContainerFooter>
                        <CircleData selectImage={false} NoSelecet={false} selecetDisabled={true} useCreaArts={true} initialIndex={0} dataAgronomo={firstCreaArt}/>

                        <CircleData selectImage={false} NoSelecet={false} selecetDisabled={true} useCreaArts={true} initialIndex={1} dataAgronomo={secondCreaArt}/>

                        <CircleData selectImage={false} NoSelecet={false} selecetDisabled={true} useCreaArts={true} initialIndex={-1} dataAgronomo={thirdCreaArt}/>

                        <CalendaryEvent />
                    </S.ContainerFooter>
                </S.ContainerBody>

                <ImportarAgronomosModal
                    show={this.state.showModalImportAgronomos}
                    onHide={() => this.setState({ showModalImportAgronomos: false })}
                    userEmail={this.state.user?.username}
                />

                <ModalGeneric
                    show={this.state.showModalPlanoSemRT}
                    onHide={() => this.setState({ showModalPlanoSemRT: false })}
                    size='md'
                >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                        <H6>Não disponível para o seu plano</H6>

                        <p className='text' style={{ marginTop: '16px' }}>
                            O seu plano não permite adicionar mais responsáveis técnicos nem adquirir novas licenças.
                        </p>
                        <p className='text'>
                            Faça um upgrade para os planos Light ou Pro e inclua mais usuários.
                        </p>

                        <ButtonV2
                            width='200px'
                            height='50px'
                            margin='16px 0px'
                            value='ATUALIZAR PLANO'
                            outline={false}
                            disabled={false}
                            loading={false}
                            onClick={() => window.location = '/planos'}
                        />
                    </div>
                </ModalGeneric>
            </S.ContainerPage>
        );
    }
}
export default Agronomos;
